<template>
  <div class="bg" @click="$emit('close')">
    <div ref="box" class="about box p-6" :style="`margin-top: ${boxMarginTop}`">
      <div class="flex justify-between items-start">
        <div>
          <h1>About</h1>
        </div>
        <div class="cursor-pointer" @click="$emit('close')">Close</div>
      </div>
      <h2>Description</h2>
      <p>
        Bicycle Built For Two Thousand is comprised of 2,088 voice recordings
        collected via Amazon's Mechanical Turk web service. Workers were
        prompted to listen to a short sound clip, then record themselves
        imitating what they heard.
      </p>

      <h2>Why this song?</h2>
      <p>
        The song "Daisy Bell," originally written by Harry Dacre in 1892, was
        made famous in 1962 by John Kelly, Max Mathews, and Carol Lockbaum as
        the first example of musical speech synthesis. In contrast to the 1962
        version, Bicycle Built For Two Thousand was synthesized with a
        distributed system of human voices from all over the world.
      </p>

      <h2>Did people know what they were submitting to?</h2>
      <p>
        Workers were asked to imitate what they heard. They were not given
        additional information.
      </p>

      <h2>
        Isn't that the song that HAL is singing at the end of 2001: A Space
        Odyssey?
      </h2>
      <p>Yes.</p>

      <h2>How much were people paid to record their voice?</h2>
      <p>$0.06 USD</p>

      <h2>Where are these people from?</h2>
      <p>
        People from 71 countries participated. The top ten were the United
        States, India, Canada, United Kingdom, Macedonia, Philippines, Germany,
        Romania, Italy, and Pakistan.
      </p>

      <h2>How did people record and submit their voice?</h2>
      <p>
        In a web browser, through a custom audio recording tool created in
        Processing.
      </p>

      <h2>Credits</h2>
      <p v-if="kiosk">
        Aaron Koblin and Daniel Massey ©2009
      </p>
      <p v-else>
        <a href="http://aaronkoblin.com" target="_blank">Aaron Koblin</a> and
        <a href="http://daniel-massey.com" target="_blank">Daniel Massey</a>
        ©2009
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",

  data() {
    return {
      kiosk: false,
      boxMarginTop: "0"
    };
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },

  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  mounted() {
    if (this.$route.query.kiosk) {
      this.kiosk = true;
    }

    this.onResize();
  },

  methods: {
    onResize() {
      this.boxMarginTop = this.calcBoxMarginTop();
    },

    calcBoxMarginTop() {
      const h = this.$refs.box.offsetHeight;
      if (window.innerHeight < h) {
        const diff = h - window.innerHeight;
        const margin = `calc(${diff}px + 6rem)`;
        return margin;
      } else {
        return "2rem";
      }
    }
  }
};
</script>

<style scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.box {
  width: auto;
  background: white;
  border: 1px solid #999999;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
}

.box .inner {
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.about {
  max-width: 640px;
}

h2 {
  @apply mt-6;
}
</style>
